import React from "react";
import { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import villaRooftop from "./assets/modern-villa.jfif";
import commercial from "./assets/commercial.jfif";
import utility from "./assets/utility.jfif";
import public_1 from "./assets/public_1.jfif";
import residental from "./assets/residental.jfif";
import hero1 from "./assets/hero-1.jpg";
import hero2 from "./assets/hero-2.jpg";
import hero3 from "./assets/hero-3.jpg";
import home1 from "./assets/home1.jfif";
import about from "./assets/about.jpg";



const heroSlides = [
  {
    img: hero1,
    badge: "Premium Residential Solar",
    title: "Power Your Home",
    titleGold: "With the Sun",
    desc: "End-to-end solar installations engineered for modern homes — saving you up to 80% on energy bills.",
  },
  {
    img: hero2,
    badge: "Commercial & Utility Scale",
    title: "Energy That Scales",
    titleGold: "With You",
    desc: "From rooftops to solar farms — we design, build, and maintain photovoltaic systems of any size.",
  },
  {
    img: hero3,
    badge: "24/7 Maintenance & Support",
    title: "Always Generating.",
    titleGold: "Never Worried.",
    desc: "Certified technicians, proactive monitoring, and rapid on-site service — keeping your panels at peak efficiency.",
  },
  {
    img: home1,
    badge: "Commercial & Home Scale",
    title: "Energy That Scales",
    titleGold: "With You",
    desc: "From rooftops to solar farms — we design, build, and maintain photovoltaic systems of any size.",
  },
];

const services = [
  { icon: "🏠", title: "Residential Installation", desc: "Custom-designed rooftop solar systems engineered for your home, your roof, and your energy needs." },
  { icon: "🏢", title: "Commercial Solutions", desc: "Reduce operating costs with scalable PV systems for offices, warehouses, and industrial facilities." },
  { icon: "🔧", title: "Maintenance & Repair", desc: "Routine inspection, panel cleaning, inverter service, and rapid repairs to keep output at peak." },
  { icon: "🛡️", title: "24/7 Support", desc: "Real-time monitoring with a dedicated support team available around the clock — every day of the year." },
  { icon: "🔋", title: "Battery Storage", desc: "Pair your panels with intelligent battery storage to power through outages and peak-hour rates." },
  { icon: "📊", title: "Energy Audits", desc: "Detailed consumption analysis and savings projections — know exactly what solar will do for you." },
];

const portfolioProjects = [
  { category: "Residential", title: "Modern Villa Rooftop", capacity: "12 kW", img: villaRooftop },
  { category: "Commercial", title: "Logistics Hub Array", capacity: "320 kW", img: commercial },
  { category: "Utility", title: "Desert Solar Farm", capacity: "8.5 MW", img: utility },
  { category: "Public", title: "Community School", capacity: "45 kW", img: public_1 },
  { category: "Residential", title: "Suburban Family Home", capacity: "8 kW", img: residental },
  
];

const stats = [
  { value: "12+", label: "Years Experience" },
  { value: "2,400+", label: "Installations" },
  { value: "50MW", label: "Energy Generated" },
  { value: "98%", label: "Client Satisfaction" },
];

const SunIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/>
  </svg>
);

const ArrowRight = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
  </svg>
);

const SendIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/>
    <path d="m21.854 2.147-10.94 10.939"/>
  </svg>
);

const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 5h16"/><path d="M4 12h16"/><path d="M4 19h16"/>
  </svg>
);

const XIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
  </svg>
);

export default function App() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [portfolioIdx, setPortfolioIdx] = useState(0);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const slideTimer = useRef(null);

  useEffect(() => {
    slideTimer.current = setInterval(() => {
      setActiveSlide(s => (s + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(slideTimer.current);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
      const sections = ["home", "about", "services", "portfolio", "contact"];
      for (const id of sections.reverse()) {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 100) {
          setActiveSection(id);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const prevPortfolio = () => setPortfolioIdx(i => (i - 1 + portfolioProjects.length) % portfolioProjects.length);
  const nextPortfolio = () => setPortfolioIdx(i => (i + 1) % portfolioProjects.length);

  const visiblePortfolio = [0, 1, 2].map(offset => portfolioProjects[(portfolioIdx + offset) % portfolioProjects.length]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.name && form.email && form.message) setSubmitted(true);
  };

  const slide = heroSlides[activeSlide];

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: "#0d1117", color: "#e6eaf0", minHeight: "100vh" }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        body { font-family: 'Plus Jakarta Sans', sans-serif; }
        :root {
          --solar: #F5A623;
          --solar-light: #FFD166;
          --navy: #0d1117;
          --navy-mid: #161b22;
          --navy-card: #1c2330;
          --text: #e6eaf0;
          --muted: #8b95a5;
          --border: #30363d;
        }
        .gradient-solar { background: linear-gradient(135deg, #F5A623, #FFD166); }
        .gradient-navy { background: linear-gradient(135deg, #1c2330, #0d1117); }
        .text-gold { background: linear-gradient(135deg, #F5A623, #FFD166); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
        .nav-link { background: none; border: none; cursor: pointer; color: rgba(230,234,240,0.8); font-size: 0.875rem; font-weight: 500; padding: 0.5rem 1rem; border-radius: 999px; transition: all 0.2s; font-family: inherit; }
        .nav-link:hover, .nav-link.active { color: #fff; background: rgba(255,255,255,0.1); }
        .btn-primary { display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.875rem 1.75rem; border-radius: 999px; background: linear-gradient(135deg, #F5A623, #FFD166); color: #0d1117; font-weight: 700; font-size: 0.9rem; border: none; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s; box-shadow: 0 4px 20px rgba(245,166,35,0.35); font-family: inherit; }
        .btn-primary:hover { transform: scale(1.04); box-shadow: 0 6px 28px rgba(245,166,35,0.5); }
        .btn-ghost { display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.875rem 1.75rem; border-radius: 999px; background: rgba(255,255,255,0.1); color: #fff; font-weight: 600; font-size: 0.9rem; border: 1px solid rgba(255,255,255,0.2); cursor: pointer; transition: all 0.2s; backdrop-filter: blur(8px); font-family: inherit; }
        .btn-ghost:hover { background: rgba(255,255,255,0.2); }
        .card { background: var(--navy-card); border: 1px solid var(--border); border-radius: 1.25rem; transition: all 0.3s; }
        .card:hover { transform: translateY(-6px); border-color: rgba(245,166,35,0.3); box-shadow: 0 20px 60px rgba(0,0,0,0.4); }
        .service-icon { width: 56px; height: 56px; border-radius: 1rem; background: linear-gradient(135deg, #1c2330, #2d3748); display: flex; align-items: center; justify-center; font-size: 1.5rem; border: 1px solid var(--border); transition: all 0.3s; display: flex; align-items: center; justify-content: center; }
        .card:hover .service-icon { background: linear-gradient(135deg, #F5A623, #FFD166); }
        .slide-dot { width: 8px; height: 8px; border-radius: 999px; background: rgba(255,255,255,0.3); transition: all 0.3s; cursor: pointer; border: none; }
        .slide-dot.active { background: #F5A623; width: 24px; }
        .portfolio-card { position: relative; border-radius: 1.25rem; overflow: hidden; aspect-ratio: 4/5; cursor: pointer; }
        .portfolio-card img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.6s; }
        .portfolio-card:hover img { transform: scale(1.08); }
        .portfolio-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(13,17,23,0.95) 0%, rgba(13,17,23,0.3) 60%, transparent 100%); padding: 1.75rem; display: flex; flex-direction: column; justify-content: flex-end; }
        .input-field { width: 100%; padding: 1rem 1.25rem; border-radius: 0.75rem; background: rgba(255,255,255,0.05); border: 1px solid var(--border); color: var(--text); font-size: 0.95rem; font-family: inherit; outline: none; transition: all 0.2s; }
        .input-field:focus { border-color: #F5A623; background: rgba(245,166,35,0.05); box-shadow: 0 0 0 3px rgba(245,166,35,0.1); }
        .input-field::placeholder { color: var(--muted); }
        label { display: block; font-size: 0.875rem; font-weight: 600; margin-bottom: 0.5rem; color: var(--text); }
        .contact-info-card { display: flex; align-items: flex-start; gap: 1rem; padding: 1.25rem 1.5rem; border-radius: 1rem; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); transition: all 0.2s; }
        .contact-info-card:hover { background: rgba(255,255,255,0.08); }
        .whatsapp-btn { position: fixed; bottom: 1.5rem; right: 1.5rem; z-index: 100; width: 56px; height: 56px; border-radius: 999px; background: #25D366; color: #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 20px rgba(37,211,102,0.4); transition: transform 0.2s; text-decoration: none; font-size: 1.5rem; }
        .whatsapp-btn:hover { transform: scale(1.1); }
        .badge { display: inline-flex; align-items: center; gap: 0.4rem; padding: 0.3rem 0.8rem; border-radius: 999px; background: rgba(245,166,35,0.12); color: #F5A623; border: 1px solid rgba(245,166,35,0.3); font-size: 0.7rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; }
        .section-tag { display: inline-block; padding: 0.3rem 0.8rem; border-radius: 999px; background: rgba(255,255,255,0.07); color: var(--text); border: 1px solid var(--border); font-size: 0.7rem; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; }
        .nav-swipe-btn { background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); border-radius: 999px; width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #fff; transition: all 0.2s; }
        .nav-swipe-btn:hover { background: linear-gradient(135deg, #F5A623, #FFD166); color: #0d1117; border-color: transparent; }
        @media (max-width: 768px) {
          .hide-mobile { display: none !important; }
          .grid-2 { grid-template-columns: 1fr !important; }
          .grid-3 { grid-template-columns: 1fr !important; }
          .hero-title { font-size: 2.5rem !important; }
        }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
        .fade-in-up { animation: fadeInUp 0.7s ease forwards; }
        .fade-in-up-1 { animation: fadeInUp 0.7s 0.1s ease both; }
        .fade-in-up-2 { animation: fadeInUp 0.7s 0.25s ease both; }
        .fade-in-up-3 { animation: fadeInUp 0.7s 0.4s ease both; }
        @keyframes ping { 0%, 100% { transform: scale(1); opacity: 0.3; } 50% { transform: scale(1.4); opacity: 0; } }
        .ping { animation: ping 2s infinite; }
      `}</style>

      {/* HEADER */}
      <header style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 50,
        background: scrolled ? "rgba(13,17,23,0.92)" : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "none",
        transition: "all 0.3s"
      }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 1.5rem", height: 72, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <button onClick={() => scrollTo("home")} style={{ display: "flex", alignItems: "center", gap: "0.6rem", background: "none", border: "none", cursor: "pointer" }}>
            <span style={{ width: 40, height: 40, borderRadius: "0.75rem", background: "linear-gradient(135deg, #F5A623, #FFD166)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0d1117" }}>
              <SunIcon />
            </span>
            <span style={{ fontWeight: 800, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.02em" }}>
              New Suraj Solar Agency<span className="text-gold">.</span>
            </span>
          </button>

          <nav className="hide-mobile" style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
            {["home", "about", "services", "portfolio", "contact"].map(s => (
              <button key={s} className={`nav-link ${activeSection === s ? "active" : ""}`} onClick={() => scrollTo(s)}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
            <button className="btn-primary" style={{ marginLeft: "0.75rem", padding: "0.6rem 1.25rem", fontSize: "0.85rem" }} onClick={() => scrollTo("contact")}>
              Get Quote
            </button>
          </nav>

          <button style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "0.5rem", display: "none" }} className="show-mobile"
            onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            {menuOpen ? <XIcon /> : <MenuIcon />}
          </button>
          <button style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "0.5rem" }}
            onClick={() => setMenuOpen(o => !o)}>
            <span className="hide-mobile" style={{ display: "none" }} />
            <span style={{ display: "none" }} className="hide-desktop">
              {menuOpen ? <XIcon /> : <MenuIcon />}
            </span>
          </button>

          {/* Mobile toggle visible on small screens */}
          <div style={{ display: "flex" }} className="hide-mobile" />
          <button onClick={() => setMenuOpen(o => !o)}
            style={{ background: "none", border: "none", cursor: "pointer", color: "#fff" }}
            aria-label="Toggle menu">
            <span style={{ display: "block" }}>
              {menuOpen ? <XIcon /> : <MenuIcon />}
            </span>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div style={{ background: "rgba(13,17,23,0.98)", backdropFilter: "blur(16px)", padding: "1rem 1.5rem 1.5rem", borderBottom: "1px solid var(--border)" }}>
            {["home", "about", "services", "portfolio", "contact"].map(s => (
              <button key={s} style={{ display: "block", width: "100%", textAlign: "left", padding: "0.75rem 1rem", background: "none", border: "none", color: "#e6eaf0", fontSize: "1rem", fontWeight: 600, cursor: "pointer", borderRadius: "0.5rem", fontFamily: "inherit" }}
                onClick={() => scrollTo(s)}>
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
            <button className="btn-primary" style={{ marginTop: "0.5rem", width: "100%", justifyContent: "center" }} onClick={() => scrollTo("contact")}>
              Get Free Quote
            </button>
          </div>
        )}
      </header>

      {/* HERO */}
      <section id="home" style={{ position: "relative", height: "100vh", minHeight: 640, overflow: "hidden" }}>
        {heroSlides.map((s, i) => (
          <div key={i} style={{
            position: "absolute", inset: 0, transition: "opacity 0.8s ease",
            opacity: i === activeSlide ? 1 : 0, pointerEvents: i === activeSlide ? "auto" : "none"
          }}>
            <img src={s.img} alt={s.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right, rgba(13,17,23,0.85) 50%, rgba(13,17,23,0.3) 100%)" }} />
          </div>
        ))}

        <div style={{ position: "relative", zIndex: 10, height: "100%", display: "flex", alignItems: "center" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 1.5rem", width: "100%" }}>
            <div style={{ maxWidth: 680 }}>
              <span className="badge fade-in-up-1">{slide.badge}</span>
              <h1 className="hero-title fade-in-up-2" style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)", fontWeight: 800, color: "#fff", lineHeight: 1.05, margin: "1.25rem 0", letterSpacing: "-0.03em" }}>
                {slide.title} <span className="text-gold">{slide.titleGold}</span>
              </h1>
              <p className="fade-in-up-3" style={{ fontSize: "1.1rem", color: "rgba(230,234,240,0.85)", maxWidth: 540, lineHeight: 1.7, marginBottom: "2.5rem" }}>
                {slide.desc}
              </p>
              <div className="fade-in-up-3" style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                <button className="btn-primary" onClick={() => scrollTo("contact")}>
                  Get Free Quote <ArrowRight />
                </button>
                <button className="btn-ghost" onClick={() => scrollTo("services")}>
                  Our Services
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Slide controls */}
        <div style={{ position: "absolute", bottom: "2rem", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "0.5rem", zIndex: 20 }}>
          {heroSlides.map((_, i) => (
            <button key={i} className={`slide-dot ${i === activeSlide ? "active" : ""}`}
              onClick={() => { setActiveSlide(i); clearInterval(slideTimer.current); }} />
          ))}
        </div>

        {/* Stats bar */}
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, zIndex: 15 }} className="hide-mobile">
          <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 1.5rem 2rem" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 1, background: "rgba(255,255,255,0.08)", borderRadius: "1rem", overflow: "hidden", border: "1px solid rgba(255,255,255,0.1)", backdropFilter: "blur(12px)" }}>
              {stats.map(s => (
                <div key={s.label} style={{ background: "rgba(13,17,23,0.6)", padding: "1.25rem 1.5rem", textAlign: "center" }}>
                  <div className="text-gold" style={{ fontSize: "1.75rem", fontWeight: 800, letterSpacing: "-0.03em" }}>{s.value}</div>
                  <div style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(230,234,240,0.6)", marginTop: 4 }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" style={{ padding: "6rem 1.5rem", background: "var(--navy)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: "5rem", alignItems: "center" }} className="grid-2">
          <div style={{ position: "relative" }}>
            <div style={{ position: "absolute", top: -24, left: -24, width: 128, height: 128, background: "linear-gradient(135deg, #F5A623, #FFD166)", borderRadius: "2rem", opacity: 0.15, filter: "blur(24px)" }} />
            <div style={{ borderRadius: "1.5rem", overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,0.5)" }}>
              <img src={about} alt="Solar engineers" style={{ width: "100%", height: 480, objectFit: "cover", display: "block" }} />
            </div>
            <div style={{ position: "absolute", bottom: -32, right: -24, background: "var(--navy-card)", borderRadius: "1rem", padding: "1.5rem", border: "1px solid var(--border)", boxShadow: "0 16px 48px rgba(0,0,0,0.4)", maxWidth: 220 }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.5rem" }}>
                <span style={{ width: 40, height: 40, borderRadius: "0.75rem", background: "linear-gradient(135deg,#F5A623,#FFD166)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.1rem" }}>🏆</span>
                <span style={{ fontSize: "1.75rem", fontWeight: 800, color: "#fff" }}>12+</span>
              </div>
              <div style={{ fontSize: "0.8rem", color: "var(--muted)" }}>Years powering homes & businesses with clean energy</div>
            </div>
          </div>

          <div>
            <span className="section-tag">About New Suraj Solar Agency</span>
            <h2 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)", fontWeight: 800, lineHeight: 1.15, marginTop: "1.25rem", letterSpacing: "-0.03em" }}>
              Engineering a <span className="text-gold">brighter, cleaner</span> tomorrow.
            </h2>
            <p style={{ marginTop: "1.25rem", fontSize: "1rem", color: "var(--muted)", lineHeight: 1.8 }}>
              Since 2013, New Suraj Solar Agency has helped thousands of homes and businesses transition to renewable energy. We combine premium hardware, precision engineering, and a relentless focus on service to deliver solar systems that perform — for decades.
            </p>
            <ul style={{ marginTop: "2rem", listStyle: "none", display: "flex", flexDirection: "column", gap: "1rem" }}>
              {["NABCEP-certified engineers and installers", "25-year performance warranty on every panel", "End-to-end project management from design to grid connection", "Tier-1 components from world-leading manufacturers"].map(item => (
                <li key={item} style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
                  <span style={{ color: "#F5A623", fontSize: "1.1rem", marginTop: "0.1rem", flexShrink: 0 }}>✓</span>
                  <span style={{ color: "rgba(230,234,240,0.85)", fontSize: "0.95rem" }}>{item}</span>
                </li>
              ))}
            </ul>
            <button className="btn-primary" style={{ marginTop: "2.25rem" }} onClick={() => scrollTo("contact")}>
              Work With Us <ArrowRight />
            </button>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" style={{ padding: "6rem 1.5rem", background: "var(--navy-mid)", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, right: 0, width: 384, height: 384, background: "radial-gradient(circle, rgba(245,166,35,0.12), transparent 70%)", borderRadius: "50%" }} />
        <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
          <div style={{ textAlign: "center", maxWidth: 560, margin: "0 auto 3.5rem" }}>
            <span className="section-tag">Our Services</span>
            <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.75rem)", fontWeight: 800, lineHeight: 1.15, marginTop: "1.25rem", letterSpacing: "-0.03em" }}>
              Complete solar solutions, <span className="text-gold">end to end</span>.
            </h2>
            <p style={{ marginTop: "1rem", color: "var(--muted)", fontSize: "1rem", lineHeight: 1.7 }}>
              From the first consultation to decades of clean power, we handle every step.
            </p>
          </div>

          <div className="grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1.25rem" }}>
            {services.map((s, i) => (
              <article key={s.title} className="card" style={{ padding: "2rem", animationDelay: `${i * 60}ms` }}>
                <div className="service-icon">{s.icon}</div>
                <h3 style={{ marginTop: "1.5rem", fontSize: "1.1rem", fontWeight: 700, color: "#fff" }}>{s.title}</h3>
                <p style={{ marginTop: "0.75rem", fontSize: "0.9rem", color: "var(--muted)", lineHeight: 1.7 }}>{s.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* PORTFOLIO */}
      <section id="portfolio" style={{ padding: "6rem 1.5rem", background: "var(--navy)" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: "1.5rem", marginBottom: "3rem" }}>
            <div style={{ maxWidth: 480 }}>
              <span className="section-tag">Our Portfolio</span>
              <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.75rem)", fontWeight: 800, lineHeight: 1.15, marginTop: "1.25rem", letterSpacing: "-0.03em" }}>
                Projects that <span className="text-gold">power the future</span>.
              </h2>
            </div>
            <div style={{ display: "flex", gap: "0.75rem" }}>
              <button className="nav-swipe-btn" onClick={prevPortfolio} aria-label="Previous">‹</button>
              <button className="nav-swipe-btn" onClick={nextPortfolio} aria-label="Next">›</button>
            </div>
          </div>

          <div className="grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1.25rem" }}>
            {visiblePortfolio.map((p) => (
              <div key={p.title} className="portfolio-card" style={{ border: "1px solid var(--border)" }}>
                <img src={p.img} alt={p.title} loading="lazy" />
                <div className="portfolio-overlay">
                  <span style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.1em", color: "#F5A623", fontWeight: 700 }}>{p.category}</span>
                  <h3 style={{ marginTop: "0.5rem", fontSize: "1.2rem", fontWeight: 700, color: "#fff" }}>{p.title}</h3>
                  <div style={{ marginTop: "1rem", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.7)" }}>Capacity · <strong style={{ color: "#fff" }}>{p.capacity}</strong></span>
                    <span style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(255,255,255,0.1)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>↗</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" style={{ padding: "6rem 1.5rem", background: "linear-gradient(135deg, #0d1117, #111827)", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: "25%", left: -128, width: 384, height: 384, background: "rgba(245,166,35,0.12)", borderRadius: "50%", filter: "blur(80px)" }} />
        <div style={{ position: "absolute", bottom: 0, right: -128, width: 384, height: 384, background: "rgba(245,166,35,0.06)", borderRadius: "50%", filter: "blur(80px)" }} />
        <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative" }}>
          <div style={{ maxWidth: 520, marginBottom: "3.5rem" }}>
            <span className="badge">Get in touch</span>
            <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.75rem)", fontWeight: 800, lineHeight: 1.15, marginTop: "1.25rem", color: "#fff", letterSpacing: "-0.03em" }}>
              Let's build your <span className="text-gold">solar future</span>.
            </h2>
            <p style={{ marginTop: "1rem", fontSize: "1rem", color: "rgba(230,234,240,0.7)", lineHeight: 1.7 }}>
              Tell us about your property and energy goals — we'll get back within one business day with a free site assessment.
            </p>
          </div>

          <div className="grid-2" style={{ display: "grid", gridTemplateColumns: "2fr 3fr", gap: "2rem", alignItems: "start" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              {[
                { icon: "📍", label: "Visit our office", value: "1. Buria Chowk, Indira Colony, Jagadhri 135101\n2. Opp. Anu Dhaba, near PNB Bank Radour 135133" },
                { icon: "📞", label: "Call us anytime", value: "+91 9991081819, +91 9050408131" },
                { icon: "✉️", label: "Email", value: "support@newsurajsolaragency.com" },
              ].map(c => (
                <div key={c.label} className="contact-info-card">
                  <div style={{ width: 48, height: 48, borderRadius: "0.75rem", background: "linear-gradient(135deg,#F5A623,#FFD166)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem", flexShrink: 0 }}>
                    {c.icon}
                  </div>
                  <div>
                    <div style={{ fontSize: "0.65rem", textTransform: "uppercase", letterSpacing: "0.1em", color: "#F5A623", fontWeight: 700 }}>{c.label}</div>
                    <div style={{ marginTop: "0.25rem", color: "#fff", fontWeight: 500, fontSize: "0.9rem", lineHeight: 1.5, whiteSpace: "pre-line" }}>{c.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ background: "var(--navy-card)", borderRadius: "1.5rem", padding: "2.5rem", border: "1px solid var(--border)" }}>
              {submitted ? (
                <div style={{ textAlign: "center", padding: "3rem 1rem" }}>
                  <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>☀️</div>
                  <h3 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#fff", marginBottom: "0.75rem" }}>Message Sent!</h3>
                  <p style={{ color: "var(--muted)" }}>We'll get back to you within one business day with your free site assessment.</p>
                  <button className="btn-primary" style={{ marginTop: "1.5rem" }} onClick={() => { setSubmitted(false); setForm({ name: "", email: "", message: "" }); }}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="grid-2" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: "1.25rem" }}>
                    <div>
                      <label htmlFor="name">Name</label>
                      <input id="name" type="text" className="input-field" placeholder="Jane Doe"
                        value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
                    </div>
                    <div>
                      <label htmlFor="email">Email</label>
                      <input id="email" type="email" className="input-field" placeholder="jane@email.com"
                        value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
                    </div>
                  </div>
                  <div style={{ marginTop: "1.25rem" }}>
                    <label htmlFor="message">Message</label>
                    <textarea id="message" className="input-field" rows={5} placeholder="Tell us about your property, roof type, and energy goals..."
                      style={{ resize: "none" }} value={form.message}
                      onChange={e => setForm(f => ({ ...f, message: e.target.value }))} required />
                  </div>
                  <button type="submit" className="btn-primary" style={{ marginTop: "1.75rem", width: "100%", justifyContent: "center" }}>
                    Send Message <SendIcon />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background: "#080c11", color: "rgba(230,234,240,0.7)", paddingTop: "4rem", paddingBottom: "2rem" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 1.5rem" }}>
          <div className="grid-2" style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1.5fr", gap: "3rem", paddingBottom: "3rem", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
                <span style={{ width: 40, height: 40, borderRadius: "0.75rem", background: "linear-gradient(135deg,#F5A623,#FFD166)", display: "flex", alignItems: "center", justifyContent: "center", color: "#0d1117" }}>
                  <SunIcon />
                </span>
                <span style={{ fontWeight: 800, fontSize: "1rem", color: "#fff" }}>New Suraj Solar Agency<span className="text-gold">.</span></span>
              </div>
              <p style={{ marginTop: "1.25rem", maxWidth: 360, lineHeight: 1.7, fontSize: "0.9rem" }}>
                Premium solar installation, maintenance and support — engineered to perform for decades.
              </p>
              <div style={{ display: "flex", gap: "0.75rem", marginTop: "1.5rem" }}>
                {["f", "in", "tw", "ig"].map(s => (
                  <a key={s} href="#" style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", textDecoration: "none", color: "rgba(230,234,240,0.7)", fontSize: "0.75rem", fontWeight: 700, transition: "all 0.2s" }}
                    onMouseEnter={e => { e.target.style.background = "linear-gradient(135deg,#F5A623,#FFD166)"; e.target.style.color = "#0d1117"; }}
                    onMouseLeave={e => { e.target.style.background = "rgba(255,255,255,0.05)"; e.target.style.color = "rgba(230,234,240,0.7)"; }}>
                    {s}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4 style={{ color: "#fff", fontWeight: 700, marginBottom: "1.25rem", fontSize: "0.95rem" }}>Quick Links</h4>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "0.75rem", fontSize: "0.875rem" }}>
                {["home", "about", "services", "portfolio", "contact"].map(s => (
                  <li key={s}>
                    <button style={{ background: "none", border: "none", color: "rgba(230,234,240,0.7)", cursor: "pointer", fontSize: "0.875rem", fontFamily: "inherit", padding: 0, transition: "color 0.2s" }}
                      onClick={() => scrollTo(s)}
                      onMouseEnter={e => e.target.style.color = "#F5A623"}
                      onMouseLeave={e => e.target.style.color = "rgba(230,234,240,0.7)"}>
                      {s.charAt(0).toUpperCase() + s.slice(1)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 style={{ color: "#fff", fontWeight: 700, marginBottom: "1.25rem", fontSize: "0.95rem" }}>Get in touch</h4>
              <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "0.75rem", fontSize: "0.875rem", lineHeight: 1.6 }}>
                <li>Buria Chowk, Indira Colony, Jagadhri 135101</li>
                <li>Opp. Anu Dhaba, near PNB Bank Radaur 135133</li>
                <li>+91 9991081819, +91 9050408131</li>
                <li>support@newsurajsolaragency.com</li>
              </ul>
            </div>
          </div>
          <div style={{ paddingTop: "1.5rem", display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "0.75rem", fontSize: "0.8rem" }}>
            <span>© 2026 New Suraj Solar Agency. All rights reserved.</span>
            <span>Powered by the sun through New Suraj Solar Agency ☀️</span>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a href="https://wa.me/919991081819?text=Hello%20New%20Suraj%20Solar%20Agency!%20I%20would%20like%20to%20inquire%20about%20your%20solar%20services."
        target="_blank" rel="noopener noreferrer" className="whatsapp-btn" aria-label="Chat on WhatsApp">
        <span style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "#25D366" }} className="ping" />
        <span style={{ position: "relative", fontSize: "1.5rem" }}>💬</span>
      </a>
    </div>
  );
}

// If this file is loaded directly by the browser (via index.html), mount the app to #root
if (typeof document !== "undefined") {
  const rootEl = document.getElementById("root");
  if (rootEl) ReactDOM.createRoot(rootEl).render(<App />);
}
